module.exports = __webpack_public_path__ + "static/img/ups-battery-01@t.8ca9a88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/ups-battery-01@t.jpg
// module id = yjvz
// module chunks = 0